import { MapHudButton } from '../map_hud_button/MapHudButton';
import plaqueImg from './plaque.png';
import { PlayerLevelNameText } from './PlayerLevelNameText';
import './PlayerLevelScreenButton.css';

type PlayerLevelScreenButtonProps = {
  onClick?: () => void;
  /** Dynamic level name (Figma 188:9318 layouts). */
  name?: string;
};

/**
 * Figma `link_wind_cloud` (104:24609) — 345.358 × 26, 388×97.
 * PNG without baked shadow/backdrop; white shadow via CSS filter.
 */
export function PlayerLevelScreenButton({
  onClick,
  name,
}: PlayerLevelScreenButtonProps) {
  return (
    <MapHudButton
      className="player-level-screen-button"
      ariaLabel={name ? `Уровень: ${name}` : 'Уровень игрока'}
      onClick={onClick}
    >
      <img
        className="player-level-screen-button__plaque"
        src={plaqueImg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <PlayerLevelNameText name={name} />
    </MapHudButton>
  );
}
